import * as Yup from "yup";

import { Form, Text } from "../../../../../Components/Form";
import { isValidIranianNationalCode } from "../../../../../Utils/Helpers";

const validationSchema = Yup.object({
  nat_code: Yup.string()
    .required("کد ملی الزامی است")
    .min(10, "کد ملی باید 10 رقم باشد.")
    .max(10, "کد ملی باید 10 رقم باشد.")
    .test(
      "nat_code",
      ("nat_code", "فرمت کد ملی وارد شده اشتباه است"),
      (value) => isValidIranianNationalCode(value)
    ),
});

const Search = ({ onSubmit, serverErrors, loading }) => {
  return (
    <Form
      initialValues={{
        nat_code: "",
      }}
      validationSchema={validationSchema}
      defaultActions={false}
      onSubmit={onSubmit}
    >
      <div className='row'>
        <div className='col-12 col-md-10'>
          <Text
            name='nat_code'
            title='کد ملی *'
            serverError={serverErrors?.nat_code}
            containerClass='d-flex flex-column justify-content-start align-items-start'
            labelClass='tetx-right mx-2 f-13'
          />
        </div>
        <div className='col-12 col-md-2 mt-4'>
          {loading ? (
            <button className='btn bg-purple w-100 f-13 text-white mt-1'>
              <div
                className='spinner-border text-white spinner-border-sm mb-1'
                role='status'
              >
                <span className='sr-only'></span>
              </div>
            </button>
          ) : (
            <button
              type='submit'
              className='btn bg-purple w-100 f-13 text-white mt-1'
            >
              جستجو
            </button>
          )}
        </div>
      </div>
    </Form>
  );
};
export default Search;
